module.exports = __webpack_public_path__ + "static/media/clear.167ae7f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clear.svg
// module id = 286
// module chunks = 7